module.exports = __webpack_public_path__ + "static/media/balbed.9f4dfa57.png";